import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator expects this substring when file contains writing steps. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקול שמקטין אותי",
    opening: localizedGenderNode(
      [
        "יש בי קול שלא תמיד צועק.",
        "לפעמים הוא פשוט מוריד אותי קצת.",
        "קצת פחות ראוי.",
        "קצת פחות מספיק.",
        "קצת פחות שווה.",
        "וכמעט בלי לשים לב",
        "אני כבר מאמין לו.",
      ],
      [
        "יש בי קול שלא תמיד צועק.",
        "לפעמים הוא פשוט מוריד אותי קצת.",
        "קצת פחות ראויה.",
        "קצת פחות מספיקה.",
        "קצת פחות שווה.",
        "וכמעט בלי לשים לב",
        "אני כבר מאמינה לו.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["רגע.", "אני לא מתווכח עם הקול עכשיו.", "אני רק שם לב שהוא כבר כאן."],
      ["רגע.", "אני לא מתווכחת עם הקול עכשיו.", "אני רק שמה לב שהוא כבר כאן."]
    ),
    prompts: localizedGenderNode(
      [
        "הרגעים שבהם הקול הזה כבר כאן בפנים.",
        "משפט שחוזר בי בלי שאני בוחר.",
        "בגוף, כשאני כבר מאמין לו — משהו שם.",
      ],
      [
        "הרגעים שבהם הקול הזה כבר כאן בפנים.",
        "משפט שחוזר בי בלי שאני בוחרת.",
        "בגוף, כשאני כבר מאמינה לו — משהו שם.",
      ]
    ),
    closing: localizedGenderNode(
      ["הקול הזה כבר מוכר לי.", "קצת מרחק נכנס בינינו."],
      ["הקול הזה כבר מוכר לי.", "קצת מרחק נכנס בינינו."]
    ),
    action: localizedGenderNode(
      "היום אני עוצר פעם אחת ואומר בשקט: זה קול, לא כל מי שאני.",
      "היום אני עוצרת פעם אחת ואומרת בשקט: זה קול, לא כל מי שאני."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע שבו הערך שלי נופל",
    opening: localizedGenderNode([
      "לפעמים זה קורה מהר.",
      "תגובה אחת.",
      "השוואה אחת.",
      "מבט אחד.",
      "ומשהו בי כבר יורד.",
      "כאילו הערך שלי תלוי ברגע הזה.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני נשאר רגע ממש בנקודת הנפילה הזאת.", "לפני שהכול נסגר סביבי."],
      ["אני נשארת רגע ממש בנקודת הנפילה הזאת.", "לפני שהכול נסגר סביבי."]
    ),
    prompts: localizedGenderNode([
      "רגע לפני שאני כבר מרגיש פחות — משהו שם.",
      "הדבר הראשון שעולה שם, בי.",
      "משהו שדוחף את הירידה מבפנים מהר מדי.",
    ], [
      "רגע לפני שאני כבר מרגישה פחות — משהו שם.",
      "הדבר הראשון שעולה שם, בי.",
      "משהו שדוחף את הירידה מבפנים מהר מדי.",
    ]),
    closing: localizedGenderNode(
      ["רגע ההקטנה נראה לי מבפנים.", "רק שמתי לב."],
      ["רגע ההקטנה נראה לי מבפנים.", "רק שמתי לב."]
    ),
    action: localizedGenderNode(
      "היום אני שם לב לנקודה הראשונה שבה הערך שלי מתחיל לרדת.",
      "היום אני שמה לב לנקודה הראשונה שבה הערך שלי מתחיל לרדת."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "איך זה יושב בגוף",
    opening: localizedGenderNode([
      "התחושה הזאת לא נשארת רק בראש.",
      "החזה שוקע.",
      "הבטן נסגרת.",
      "המבט יורד.",
      "אני תופס פחות מקום.",
      "כאילו הגוף שלי כבר קיבל את פסק הדין.",
    ], [
      "התחושה הזאת לא נשארת רק בראש.",
      "החזה שוקע.",
      "הבטן נסגרת.",
      "המבט יורד.",
      "אני תופסת פחות מקום.",
      "כאילו הגוף שלי כבר קיבל את פסק הדין.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני מרגיש איך הגוף שלי מחזיק את ההקטנה הזאת."],
      ["אני מרגישה איך הגוף שלי מחזיק את ההקטנה הזאת."]
    ),
    prompts: localizedGenderNode(
      [
        "התחושה של פחות — איפה היא יושבת בגוף שלי עכשיו.",
        "הגוף שם — כמו מנסה להגן על משהו.",
        "ריכוך קטן — נשימה, יד — איך זה מרגיש שם בפנים.",
      ],
      [
        "התחושה של פחות — איפה היא יושבת בגוף שלי עכשיו.",
        "הגוף שם — כמו מנסה להגן על משהו.",
        "ריכוך קטן — נשימה, יד — איך זה מרגיש שם בפנים.",
      ]
    ),
    closing: localizedGenderNode(
      ["הגוף שלי מחזיק הרבה מהתחושה הזאת.", "נשארתי לידו רגע."],
      ["הגוף שלי מחזיק הרבה מהתחושה הזאת.", "נשארתי לידו רגע."]
    ),
    action: localizedGenderNode(
      "היום אני מניח יד על הגוף ונושם פעם אחת כשאני מצטמצם.",
      "היום אני מניחה יד על הגוף ונושמת פעם אחת כשאני מצטמצמת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "איך אני כבר מוכיח לעצמי שאני פחות",
    opening: localizedGenderNode([
      "אני מתחיל לראות את הדפוס הזה.",
      "אני אוסף סימנים נגדי.",
      "זוכר יותר את מה שלא עבד.",
      "מקטין את מה שכן.",
      "ומסדר לעצמי סיפור",
      "שמסביר למה אני פחות.",
    ], [
      "אני מתחילה לראות את הדפוס הזה.",
      "אני אוספת סימנים נגדי.",
      "זוכרת יותר את מה שלא עבד.",
      "מקטינה את מה שכן.",
      "ומסדרת לעצמי סיפור",
      "שמסביר למה אני פחות.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני עוצר רגע בין מה שקרה", "לבין איך שאני כבר משתמש בזה נגדי."],
      ["אני עוצרת רגע בין מה שקרה", "לבין איך שאני כבר משתמשת בזה נגדי."]
    ),
    prompts: localizedGenderNode(
      [
        "הדרך שבה אני שוב מוכיח לעצמי שאני פחות.",
        "מה אני מגדיל נגדי בלי לשים לב.",
        "מה שעובד בי — ואני כמעט לא נשאר שם.",
      ],
      [
        "הדרך שבה אני שוב מוכיחה לעצמי שאני פחות.",
        "מה אני מגדילה נגדי בלי לשים לב.",
        "מה שעובד בי — ואני כמעט לא נשארת שם.",
      ]
    ),
    closing: localizedGenderNode(
      ["ראיתי את הדרך שבה אני בונה את זה.", "זה כבר פחות שקוף לי."],
      ["ראיתי את הדרך שבה אני בונה את זה.", "זה כבר פחות שקוף לי."]
    ),
    action: localizedGenderNode(
      "היום אני מסמן לעצמי פעם אחת שבה אני שוב משתמש במשהו נגדי.",
      "היום אני מסמנת לעצמי פעם אחת שבה אני שוב משתמשת במשהו נגדי."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה אני מפחד שזה אומר עליי",
    opening: localizedGenderNode([
      "מתחת לירידה הזאת בתחושת הערך",
      "יש גם פחד.",
      "שאם אני לא מספיק כאן,",
      "אז אולי אני פשוט לא מספיק בכלל.",
      "שזה לא רגע.",
      "שזה מי שאני.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני נשאר רגע ליד המשמעות שאני נותן לזה."],
      ["אני נשארת רגע ליד המשמעות שאני נותנת לזה."]
    ),
    prompts: localizedGenderNode([
      "הפחד שמספר לי מה הרגע הזה אומר עליי.",
      "משפט ישן שמתעורר שם בתוכי.",
      "החלק החם ביותר בפחד הזה.",
    ], [
      "הפחד שמספר לי מה הרגע הזה אומר עליי.",
      "משפט ישן שמתעורר שם בתוכי.",
      "החלק החם ביותר בפחד הזה.",
    ]),
    closing: localizedGenderNode(
      ["שמעתי את הפחד שמתחת להקטנה.", "הוא נוגע עמוק בערך שלי."],
      ["שמעתי את הפחד שמתחת להקטנה.", "הוא נוגע עמוק בערך שלי."]
    ),
    action: localizedGenderNode(
      "היום אני קורא לפחד הזה בשם פעם אחת בשקט.",
      "היום אני קוראת לפחד הזה בשם פעם אחת בשקט."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "החלק שכבר מאמין לזה",
    opening: localizedGenderNode([
      "יש בי גם חלק שכבר התרגל לזה.",
      "שכבר מאמין שאני פחות.",
      "שלא מצפה ליותר מדי.",
      "שלא מתפלא כשאני שוב נסגר.",
      "הוא לא צועק.",
      "הוא פשוט חי שם הרבה זמן.",
    ], [
      "יש בי גם חלק שכבר התרגל לזה.",
      "שכבר מאמין שאני פחות.",
      "שלא מצפה ליותר מדי.",
      "שלא מתפלאת כשאני שוב נסגרת.",
      "הוא לא צועק.",
      "הוא פשוט חי שם הרבה זמן.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני רואה את החלק שכבר מאמין לסיפור הזה."],
      ["אני רואה את החלק שכבר מאמינה לסיפור הזה."]
    ),
    prompts: localizedGenderNode([
      "המקום בתוכי שכבר מאמין שאני פחות.",
      "החלק הזה — איך הוא נוגע בבחירות שלי.",
      "משהו שהחלק הזה מבקש ממני בלי מילים.",
    ], [
      "המקום בתוכי שכבר מאמינה שאני פחות.",
      "החלק הזה — איך הוא נוגע בבחירות שלי.",
      "משהו שהחלק הזה מבקש ממני בלי מילים.",
    ]),
    closing: localizedGenderNode(
      ["יש בי חלק שמחזיק את האמונה הזאת כבר זמן רב.", "היום רק רואה אותו קצת יותר מקרוב."],
      ["יש בי חלק שמחזיק את האמונה הזאת כבר זמן רב.", "היום רק רואה אותו קצת יותר מקרוב."]
    ),
    action: localizedGenderNode(
      "היום אני שם לב לפעם אחת שבה החלק הזה מנהל אותי.",
      "היום אני שמה לב לפעם אחת שבה החלק הזה מנהל אותי."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "מה אני באמת מחפש מתחת לזה",
    opening: localizedGenderNode(
      [
        "מאחורי כל זה",
        "יש גם צורך פשוט.",
        "להרגיש בעל ערך.",
        "להרגיש שיש לי מקום.",
        "להרגיש בלי חובה להוכיח כל הזמן",
        "כדי להישאר שווה.",
      ],
      [
        "מאחורי כל זה",
        "יש גם צורך פשוט.",
        "להרגיש בעלת ערך.",
        "להרגיש שיש לי מקום.",
        "להרגיש בלי חובה להוכיח כל הזמן",
        "כדי להישאר שווה.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["אני מקשיב לצורך הזה בלי לזלזל בו."],
      ["אני מקשיבה לצורך הזה בלי לזלזל בו."]
    ),
    prompts: localizedGenderNode([
      "מתחת לפחות — צורך שם, בלי לבקש בקול.",
      "יציבות קטנה מבפנים — איך זה נשמע לי כשאני עוצר.",
      "בקשה עדינה מעצמי — איך היא מרגישה בפנים.",
    ], [
      "מתחת לפחות — צורך שם, בלי לבקש בקול.",
      "יציבות קטנה מבפנים — איך זה נשמע לי כשאני עוצרת.",
      "בקשה עדינה מעצמי — איך היא מרגישה בפנים.",
    ]),
    closing: localizedGenderNode(
      ["יש בי צורך אמיתי בתחושת ערך.", "גם הצורך הזה מקבל מקום קטן."],
      ["יש בי צורך אמיתי בתחושת ערך.", "גם הצורך הזה מקבל מקום קטן."]
    ),
    action: localizedGenderNode(
      "היום אני נותן לצורך הזה רגע אחד קטן של מקום.",
      "היום אני נותנת לצורך הזה רגע אחד קטן של מקום."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "לא לדבר אל עצמי מלמעלה",
    opening: localizedGenderNode([
      "כשאני מרגיש פחות,",
      "הטון שלי עם עצמי נהיה קר.",
      "מבטל.",
      "מלמעלה.",
      "כאילו אני כבר אכזבה ברורה.",
      "וזה מוריד אותי עוד יותר.",
    ], [
      "כשאני מרגישה פחות,",
      "הטון שלי עם עצמי נהיה קר.",
      "מבטל.",
      "מלמעלה.",
      "כאילו אני כבר אכזבה ברורה.",
      "וזה מוריד אותי עוד יותר.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני שומע איך אני מדבר אל עצמי בתוך הירידה הזאת."],
      ["אני שומעת איך אני מדברת אל עצמי בתוך הירידה הזאת."]
    ),
    prompts: localizedGenderNode([
      "הטון שלי מול עצמי כשאני כבר מרגיש פחות.",
      "מילים שחסרות לי שם, מתחת לטון הקר.",
      "משפט שפחות מקטין — עדיין אמיתי בפנים.",
    ], [
      "הטון שלי מול עצמי כשאני כבר מרגישה פחות.",
      "מילים שחסרות לי שם, מתחת לטון הקר.",
      "משפט שפחות מקטין — עדיין אמיתי בפנים.",
    ]),
    closing: localizedGenderNode(
      ["הטון שלי משנה את כל העומק של הנפילה.", "זה נשאר איתי ככה."],
      ["הטון שלי משנה את כל העומק של הנפילה.", "זה נשאר איתי ככה."]
    ),
    action: localizedGenderNode(
      "היום אני אומר לעצמי משפט אחד שלא מדבר אליי מלמעלה.",
      "היום אני אומרת לעצמי משפט אחד שלא מדבר אליי מלמעלה."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "לא כל חולשה היא הוכחה",
    opening: localizedGenderNode([
      "אולי לא כל היסוס אומר שאני חלש.",
      "לא כל טעות אומרת שאני פחות.",
      "לא כל קושי הוא הוכחה נגדי.",
      "לפעמים אני קופץ מהר מדי",
      "ממה שקורה",
      "למי שזה אומר שאני.",
    ], [
      "אולי לא כל היסוס אומר שאני חלשה.",
      "לא כל טעות אומרת שאני פחות.",
      "לא כל קושי הוא הוכחה נגדי.",
      "לפעמים אני קופצת מהר מדי",
      "ממה שקורה",
      "למי שזה אומר שאני.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני חוזר למה שקרה באמת", "ולא רק למה שכבר הסקתי על עצמי."],
      ["אני חוזרת למה שקרה באמת", "ולא רק למה שכבר הסקתי על עצמי."]
    ),
    prompts: localizedGenderNode([
      "מה שקרה — לעומת מה שהרגשה כבר סיפרה לי על עצמי.",
      "המסקנה שאני קופץ אליה מהר על עצמי.",
      "עוד אפשרות קטנה — רק נוכחת שם, בלי להכריע.",
    ], [
      "מה שקרה — לעומת מה שהרגשה כבר סיפרה לי על עצמי.",
      "המסקנה שאני קופצת אליה מהר על עצמי.",
      "עוד אפשרות קטנה — רק נוכחת שם, בלי להכריע.",
    ]),
    closing: localizedGenderNode(
      ["משהו אחר נכח בי ליד מה שקרה.", "קצת פחות קשיחות בפנים."],
      ["משהו אחר נכח בי ליד מה שקרה.", "קצת פחות קשיחות בפנים."]
    ),
    action: localizedGenderNode(
      "היום אני מחזיק אפשרות אחת נוספת חוץ מ\"אני פחות\".",
      "היום אני מחזיקה אפשרות אחת נוספת חוץ מ\"אני פחות\"."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "רגע לפני שאני מקטין את עצמי",
    opening: localizedGenderNode([
      "יש רגע שבו אני כבר עושה את זה לבד.",
      "מקטין את עצמי לפני שמישהו אחר בכלל אמר משהו.",
      "מוותר מראש.",
      "מתכווץ מראש.",
      "ואני רוצה לראות את הרגע הזה.",
    ], [
      "יש רגע שבו אני כבר עושה את זה לבד.",
      "מקטינה את עצמי לפני שמישהו אחר בכלל אמר משהו.",
      "מוותרת מראש.",
      "מתכווצת מראש.",
      "ואני רוצה לראות את הרגע הזה.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני עוצר רגע לפני שאני שוב מוריד את עצמי מבפנים."],
      ["אני עוצרת רגע לפני שאני שוב מורידה את עצמי מבפנים."]
    ),
    prompts: localizedGenderNode([
      "ההקטנה שמגיעה לפני שמשהו בכלל קורה.",
      "משהו שאני מנסה להגן עליו כשאני מקטין מראש.",
      "לפני האוטומט של להקטין — רגע קטן שאני מזהה בי.",
    ], [
      "ההקטנה שמגיעה לפני שמשהו בכלל קורה.",
      "משהו שאני מנסה להגן עליו כשאני מקטינה מראש.",
      "לפני האוטומט של להקטין — רגע קטן שאני מזהה בי.",
    ]),
    closing: localizedGenderNode(
      ["ההקטנה המוקדמת נראית לי יותר בבירור.", "רק עצרתי רגע ליד זה."],
      ["ההקטנה המוקדמת נראית לי יותר בבירור.", "רק עצרתי רגע ליד זה."]
    ),
    action: localizedGenderNode(
      "היום אני נשאר עוד רגע אחד לפני שאני מקטין את עצמי.",
      "היום אני נשארת עוד רגע אחד לפני שאני מקטינה את עצמי."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "לראות גם משהו שחי בי",
    opening: localizedGenderNode([
      "כשאני בתוך התחושה הזאת,",
      "אני רואה רק מה חסר בי.",
      "אבל יש בי גם דברים שחיים.",
      "דברים שנשארים.",
      "דברים שלא נעלמים רק כי עברתי רגע קשה.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני נשאר רגע עם מה שעדיין חי בי — גם כשלא מרגיש חזק."],
      ["אני נשארת רגע עם מה שעדיין חי בי — גם כשלא מרגישה חזקה."]
    ),
    prompts: localizedGenderNode([
      "משהו שעדיין חי בי, גם ביום כזה.",
      "חלק בי שכמעט לא נותן לו מקום כשהערך יורד.",
      "משהו שאני מביא איתי — גם כשאני שוכח.",
    ], [
      "משהו שעדיין חי בי, גם ביום כזה.",
      "חלק בי שכמעט לא נותנת לו מקום כשהערך יורד.",
      "משהו שאני מביאה איתי — גם כשאני שוכחת.",
    ]),
    closing: localizedGenderNode(
      ["יש בי עוד משהו מעבר לנפילה.", "אפילו כשלא מרגיש."],
      ["יש בי עוד משהו מעבר לנפילה.", "אפילו כשלא מרגישה."]
    ),
    action: localizedGenderNode(
      "היום אני נזכר בדבר אחד חי בי — בלי להוכיח אותו בחוץ.",
      "היום אני נזכרת בדבר אחד חי בי — בלי להוכיח אותו בחוץ."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "להישאר עם דבר אחד בי שלא נלקח",
    opening: localizedGenderNode(
      [
        "אולי הערך שלי לא חייב לעלות ולרדת מכל תגובה.",
        "אולי יש בי משהו שנשאר שלי",
        "גם כשאני מתבלבל.",
        "גם כשאני נופל.",
        "גם כשאין לי הוכחה מבחוץ.",
      ],
      [
        "אולי הערך שלי לא חייב לעלות ולרדת מכל תגובה.",
        "אולי יש בי משהו שנשאר שלי",
        "גם כשאני מתבלבלת.",
        "גם כשאני נופלת.",
        "גם כשאין לי הוכחה מבחוץ.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["אני נשאר רגע עם מה שבי לא נלקח ממני כל כך מהר."],
      ["אני נשארת רגע עם מה שבי לא נלקח ממני כל כך מהר."]
    ),
    prompts: localizedGenderNode(
      [
        "משהו שנשאר שלי בלי אישור מבחוץ.",
        "רגעים שבהם קל לי לזכור את זה.",
        "כשהערך שוב יורד — משהו שמחזיר אותי לזה בתוכי.",
      ],
      [
        "משהו שנשאר שלי בלי אישור מבחוץ.",
        "רגעים שבהם קל לי לזכור את זה.",
        "כשהערך שוב יורד — משהו שמחזיר אותי לזה בתוכי.",
      ]
    ),
    closing: localizedGenderNode(
      ["יש בי משהו שלא כולו תלוי בנפילות האלה.", "נשאר מקום קטן של שייכות."],
      ["יש בי משהו שלא כולו תלוי בנפילות האלה.", "נשאר מקום קטן של שייכות."]
    ),
    action: localizedGenderNode(
      "היום אני חוזר לדבר אחד בי שלא נלקח ממני.",
      "היום אני חוזרת לדבר אחד בי שלא נלקח ממני."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "צעד קטן שלא יוצא מהקטנה",
    opening: localizedGenderNode([
      "אני לא בלחץ על מהפך עכשיו.",
      "מספיק לי צעד אחד קטן",
      "שלא יוצא מתוך זה שאני פחות.",
      "צעד אמיתי.",
      "קטן.",
      "אבל לא מבוטל מבפנים.",
    ], [
      "אני לא בלחץ על מהפך עכשיו.",
      "מספיק לי צעד אחד קטן",
      "שלא יוצא מתוך זה שאני פחות.",
      "צעד אמיתי.",
      "קטן.",
      "אבל לא מבוטל מבפנים.",
    ]),
    mindfulness: localizedGenderNode(
      ["אני בודק מהו הצעד הקטן שאפשר לי בלי להקטין את עצמי בדרך."],
      ["אני בודקת מהו הצעד הקטן שאפשר לי בלי להקטין את עצמי בדרך."]
    ),
    prompts: localizedGenderNode([
      "צעד קטן שאפשרי בלי לצאת מההקטנה.",
      "פחד קטן שמתעורר סביב הצעד הזה.",
      "להישאר עם זה בלי ביטחון מלא — איך זה מרגיש בפנים.",
    ], [
      "צעד קטן שאפשרי בלי לצאת מההקטנה.",
      "פחד קטן שמתעורר סביב הצעד הזה.",
      "להישאר עם זה בלי ביטחון מלא — איך זה מרגיש בפנים.",
    ]),
    closing: localizedGenderNode(
      ["בחרתי צעד קטן שלא בנוי על להקטין את עצמי.", "זה כבר כיוון אחר."],
      ["בחרתי צעד קטן שלא בנוי על להקטין את עצמי.", "זה כבר כיוון אחר."]
    ),
    action: localizedGenderNode(
      "היום אני הולך עם הצעד הקטן הזה גם אם אני לא בטוח לגמרי.",
      "היום אני הולכת עם הצעד הקטן הזה גם אם אני לא בטוחה לגמרי."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "להמשיך עם קצת יותר ערך מבפנים",
    opening: localizedGenderNode(
      [
        "התחושה הזאת עוד תחזור לפעמים.",
        "אני יודע את זה.",
        "אבל אני כבר לא חייב ליפול איתה ישר למסקנה שאני פחות.",
        "יש בי היום קצת יותר דרך",
        "לחזור לעצמי גם בתוך זה.",
      ],
      [
        "התחושה הזאת עוד תחזור לפעמים.",
        "אני יודעת את זה.",
        "אבל אני כבר לא חייבת ליפול איתה ישר למסקנה שאני פחות.",
        "יש בי היום קצת יותר דרך",
        "לחזור לעצמי גם בתוך זה.",
      ]
    ),
    mindfulness: localizedGenderNode(
      ["אני נושם וחוזר למה שבי לא תלוי רק ברגע הזה."],
      ["אני נושמת וחוזרת למה שבי לא תלוי רק ברגע הזה."]
    ),
    prompts: localizedGenderNode([
      "התחושה של פחות — איך היא מכירה לי את עצמה עכשיו.",
      "סימן ראשון שהיא עולה — אני מזהה אותו.",
      "משפט קצר שמתחיל להישאר איתי.",
    ]),
    closing: localizedGenderNode(
      ["זה לא נגמר פה.", "רק נשארתי עוד רגע עם עצמי."],
      ["זה לא נגמר פה.", "רק נשארתי עוד רגע עם עצמי."]
    ),
    action: localizedGenderNode(
      "היום אני שומר לי משפט אחד קצר שמחזיר אותי מהקטנה לערך.",
      "היום אני שומרת לי משפט אחד קצר שמחזיר אותי מהקטנה לערך."
    ),
  },
].map(buildNormalizedDay);

export const lowSelfEsteemNormalizedBlueprintHe = buildNormalizedPilotBlueprint({
  id: "low_self_esteem_14d",
  version: "normalizer_phase2_batch_03_v1",
  durationDays: 14,
  problemKey: "low_self_esteem",
  category: "self_worth",
  journeyName: {
    he: "ערך עצמי נמוך",
    en: "Low self-esteem",
    es: "Baja autoestima",
  },
  days,
});

export default lowSelfEsteemNormalizedBlueprintHe;
